<template lang="pug">
  v-dialog(v-model='dialog' persistent max-width='400px')
    v-card(grid-list-md v-if="invoice")
      v-toolbar.elevation-0(height="45" color="gray")        
        v-toolbar-title
          h1.subheading 
            span {{ $t('pageHeader.refundInvoice') }} 
            span.ml-1 {{ invoice.invoiceID }}
        v-spacer
        v-btn(icon @click='close()')
          v-icon close
      v-card-text(v-if="showStripe")
        v-layout(column)
          v-flex
            v-radio-group(v-model='paymentType', mandatory)
              v-radio(value='1')
                template(v-slot:label)
                  v-layout(column)
                    span.subheading.font-weight-regular(class="black--text") {{ refundTitle }}
                    span.caption {{ fullRefundSubTitle }}
              v-radio(value='2')
                template(v-slot:label)
                  v-layout(column)
                    span.subheading.font-weight-regular(class="black--text") Partial Refund
                    span.caption Refund a partial amount
          v-flex(v-if="paymentType === '2'")
            v-text-field.right-input(v-model="amount" label='Refund Amount')
          v-flex
            v-textarea(counter v-model="refundReason" outline :error-messages="refundReasonErrors" :label="$t('labels.reason')")
          v-flex.ml-3.mr-3.mt-1
            div.text-xs-center.caption.font-weight-regular Refund take 5 to 10 days to appear on customer statement
          v-flex.mt-5
            v-layout
              v-spacer
              v-btn(color="info" @click="refundStripe" :loading="stripeBtnLoading") {{ $t('buttons.refund') }}

      v-card-text(v-else)
        v-layout(column)
          v-flex
            v-text-field.right-input(readonly v-model="invoice.invoiceAmount" label='Amount')
          v-flex
            v-textarea(counter v-model="refundReason" outline :error-messages="refundReasonErrors"  :label="$t('labels.reason')")
          v-flex.ml-3.mr-3.mt-2
            div.text-xs-center.caption.font-weight-regular This will mark invoice unpaid so you can edit invoice and mark it paid again
          v-flex.mt-5
            v-layout
              v-spacer
              v-btn(color="info" @click="refundManual" :loading="unPaidBtnLoading") {{ $t('buttons.markUnPaid') }}



</template>

<script>
import invoiceService from "../service"
const { validationMixin } = require('vuelidate')
const {
  required,
  minLength,
  minValue,
} = require('vuelidate/lib/validators')
export default {
  props: {
    refundDialog: {
      default: false
    },
    invoice: {
      defaul: null
    }
  },
  mixins: [validationMixin],
  validations: {
    refundReason: {
      required,
      minLength: minLength(4),
    },
  },
  computed: {
    refundReasonErrors() {
      const errors = []
      if (!this.$v.refundReason.$dirty) return errors
      if (!this.$v.refundReason.required) errors.push(this.$t('validations.fieldIsRequired'))
      if (!this.$v.refundReason.minLength) errors.push(this.$t('validations.fieldMustbeatLeast4ChrLong'))
      return errors
    },
  },
  name: 'refund-invoice',
  data: () => ({
    refundTitle: 'Full Refund',
    fullRefundSubTitle: 'Refund the full amount',
    stripeBtnLoading: false,
    unPaidBtnLoading: false,
    amount: 0,
    refundReason: null,
    dialog: false,
    showStripe: false,
    paymentType: '1',
    refundedAmount: null,
    balanceRefund: null,
  }),
  watch: {
    paymentType() {
      this.amount = this.balanceRefund
    },
    refundDialog(val) {
      this.dialog = val
      if(val) {
        this.amount = this.invoice.invoiceAmount + this.invoice.taxAmount
        if(this.invoice.stripePaymentID.substring(0, 3) === "ch_") {
          this.showStripe = true
          invoiceService.getStripeCharge(this.invoice.stripePaymentID)
          .then(result => {
            console.log('stripe result', result)
            this.refundedAmount = (result.data.amount_refunded / 100).toFixed(2)
            this.balanceRefund = ((result.data.amount / 100) - this.refundedAmount).toFixed(2)
            if(result.data.refunds.length){ 
              this.refundTitle = 'Remaining amount'
              this.fullRefundSubTitle = `Refund the remaning ${this.balanceRefund} (${this.refundedAmount} has already been refunded)`
              this.amount = this.balanceRefund
            }
          })
        } else {
          this.showStripe = false
        }
      }
    }
  },
  methods: {
    empty() {
      this.refundTitle = 'Full Refund'
      this.fullRefundSubTitle = 'Refund the full amount'
      this.stripeBtnLoading = false
      this.unPaidBtnLoading = false
      this.amount = 0
      this.refundReason = null
      this.showStripe = false
      this.paymentType = '1'
      this.refundedAmount = null
      this.balanceRefund = null
      this.$v.$reset
    },
    refundStripe() {
      if (parseFloat(this.amount) > parseFloat(this.balanceRefund)) {
        this.$swal('Refund Amount', `Refund amount can't be more then invoice amount`, 'error' )
        this.amount = this.balanceRefund
        return false
      }
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.$swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        }).fire({
          type: 'error',
          title: this.$t('toastMessage.text.invalidFields')
        })
      } else {
        this.stripeBtnLoading = true
        let refundData = {
          invoiceID: this.invoiceID,
          refundReason: this.refundReason,
          refundAmount: this.amount
        }
        invoiceService.stripeRefund(this.invoice.invoiceID, refundData)
        .then(result => {
          console.log(result)
          if(result.status) {
            this.$swal.mixin({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000
            }).fire({
              type: 'success',
              title: result.data
            })
            this.$emit('invoiceRefunded')
            this.empty()
            this.stripeBtnLoading = false
          }
        }).catch(err=> {
          console.log(err)
          this.$swal('Error!', "Can't refund this invoice contact admin", 'error')
          this.stripeBtnLoading = false
        })
      }
    },
    refundManual() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.$swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        }).fire({
          type: 'error',
          title: this.$t('toastMessage.text.invalidFields')
        })
      } else {
        this.unPaidBtnLoading = true
        let refundData = {
          invoiceID: this.invoice.invoiceID,
          refundReason: this.refundReason,
          refundAmount: this.invoice.invoiceAmount + this.invoice.taxAmount
        }
        invoiceService.unPaid(this.invoice.invoiceID, refundData)
        .then(result => {
          if(result.status) {
            this.$swal.mixin({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000
            }).fire({
              type: 'success',
              title: result.data
            })
            this.$emit('invoiceRefunded')
            this.empty()
            this.unPaidBtnLoading = false
          }
        }).catch(err=> {
          console.log(err)
          this.unPaidBtnLoading = false
        })
      }
      
    },
    close() {
      this.empty()
      this.$emit('closeRefund')
    }
  }
}
</script>

<style scoped>
</style>